// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2AKuB","title":"BackImages_title__3-uqx","images":"BackImages_images__hYjx5"};